import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ApiBuilder } from '../../../api-builder/api/api-builder';
import { AppConfigService } from '../../../api-builder/config/app-config.service';
import {
  HttpRequestMethods,
  IDP_APPS
} from '../../../api-builder/models/api.constants';
import { LoggingService } from '../../../logging/logging.service';
import { PersonalizedEngineEndpointKeys } from '../data-models/flow-router-bridge.enums';
import {
  PersonalizationEngineRequest,
  PersonalizationEngineResponse
} from '../data-models/personalization-engine.interface';

@Injectable({
  providedIn: 'root'
})
export class PersonalizationEngineService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService
  ) {}

  getContent = (
    request: PersonalizationEngineRequest
  ): Observable<PersonalizationEngineResponse> =>
    new ApiBuilder<PersonalizationEngineRequest, PersonalizationEngineResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.COMMON)
      .endpointKey(
        PersonalizedEngineEndpointKeys['GET_PERSONALIZED_CONTENT_URL']
      )
      .method(HttpRequestMethods['POST'])
      .payload(request)
      .errorHandler(this.handleError.bind(this))
      .create();

  handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
